export const sasVerificationId = {
  notification: 'device-verification-',
  toast: 'device-verification-toast-',
};

export enum VerificationErrorEnum {
  FAILED_RETRY = 'verification.failed_retry',
  FAILED_ACCEPT = 'verification.failed_accept',
  WAITING_FOR_SAS_DATA = 'verification.waiting_for_sas_data',
  INVALID_SECURITY_CODE = 'verification.invalid_security_code',
  /**
   * The security code decrypted secret storage, but cross-signing private keys could not be
   * imported because the user's public cross-signing identity on the homeserver is broken or
   * absent (e.g. poisoned accounts where /keys/query returns NoSignatureFound). The only viable
   * recovery is to reset keys; the unlock flow surfaces this distinct error so the UI can route
   * the user to the reset-keys option instead of looping on a generic failure.
   */
  BROKEN_CROSS_SIGNING_IDENTITY = 'verification.broken_cross_signing_identity',
  UNKNOWN_ERROR = 'verification.unknown_error',
}
